import { Typography, TYPOGRAPHY_WEIGHT } from '../../components/Typography'
import { daysBetweenCalculation, defaultDateFormat } from '../../helper/dates'
import { TContractCategoryDetails } from './types'
import { ContractCategoryStatus } from '../Categories/types'
import { CATEGORY_STATUS_TO_LABEL } from './constants'

export const getStatusLabel = (data: TContractCategoryDetails) => {
  if (!data.status) {
    return ''
  }
  const label = CATEGORY_STATUS_TO_LABEL[data.status]
  let dateValue: string | null = null
  if (data.status === ContractCategoryStatus.CREATED) {
    dateValue = data.created_at
  } else if (
    data.status === ContractCategoryStatus.CONTRACTING ||
    data.status === ContractCategoryStatus.LOADING
  ) {
    dateValue = data.earliest_contract_start_date
  } else if (data.status === ContractCategoryStatus.RFP) {
    dateValue = data.status_change_date
  } else {
    dateValue = data.latest_contract_finish_date
  }
  if (!dateValue) {
    return ''
  }
  const date =
    data.status === ContractCategoryStatus.ACTIVE
      ? `${daysBetweenCalculation(dateValue)} days`
      : defaultDateFormat(dateValue)

  return (
    <Typography.Label weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
      {label} {date}
    </Typography.Label>
  )
}
